import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import clsx from 'clsx';
import { connect } from 'react-redux';

// Material UI
import { Grid, Box, Button, Card, CardContent, Paper, IconButton, InputBase, Typography, Icon, TextField, MenuItem } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ChipFilter from '../../../../design-system/components/Chip/ChipFilter';
import { degreeStyles } from '../../../../assets/styles/jss/pages/degreeCertificates/DegreeStyles';

// SDK
import { ThinkificService } from '@sdk-point/talisis';
const ThinkificServiceSDK = new ThinkificService(process.env.REACT_APP_ENV_V2, process.env.REACT_APP_X_API_KEY_V2);

const RulesFilters = (props) => {
    const classes = degreeStyles();
    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = React.useState(false);
    const [inputSearch, setInputSearch] = React.useState('');
    const [filters, setFilters] = React.useState([]);
    const [selectedFilters, setSelectedFilters] = React.useState({});
    const [showFilter, setShowFilter] = React.useState(false);

    const [bundleOptions, setBundleOptions] = React.useState([]);
    const [microcredentialOptions, setMicrocredentialOptions] = React.useState([]);
    const [badgeOptions, setBadgeOptions] = React.useState([]);
    const [state, setState] = React.useState({ data: [], dataSource: [] });

    const valueFilterLabels = { bundle: 'Bundle', microcredential: 'Microcredencial', badge: 'Insignia' };
    const valueFilterQueryStringURL = { bundle: 'bundleId', microcredential: 'microcredentialId', badge: 'badgeId' };

    const initialized = React.useRef(false);

    React.useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        const init = async () => {
            setLoading(true);
            const params = queryString.parse(location.search);
            setSelectedFilters(params);

            // Cargar catálogos
            const [bundles, micros, badges] = await Promise.all([
                ThinkificServiceSDK.getCatalogs({ CatalogType: 'bundle' }),
                ThinkificServiceSDK.getCatalogs({ CatalogType: 'microcredential' }),
                ThinkificServiceSDK.getCatalogs({ CatalogType: 'badge' }),
            ]);

            if (bundles.success) setBundleOptions(bundles.data.map(i => ({ id: i.id, label: i.name })));
            if (micros.success) setMicrocredentialOptions(micros.data.map(i => ({ id: i.id, label: i.name })));
            if (badges.success) setBadgeOptions(badges.data.map(i => ({ id: i.id, label: i.name })));

            setLoading(false);
        };

        init();
    }, []);

    React.useEffect(() => {
        // Solo ejecutar cuando haya catálogos cargados y filtros seleccionados
        if (
            !Object.keys(selectedFilters).length ||
            (!bundleOptions.length && !microcredentialOptions.length && !badgeOptions.length)
        ) return;

        handleFilterUrl(selectedFilters);
    }, [bundleOptions, microcredentialOptions, badgeOptions, selectedFilters]);








    const handleChangeFilter = (e) => {
        const { name, value } = e.target;
        const filter = { [name]: value, label: `${valueFilterLabels[name]}: ${value}` };
        setFilters([...filters, filter]);
        setSelectedFilters({ ...selectedFilters, [valueFilterQueryStringURL[name]]: value });
    };

    const handleDeleteChip = (chipToDelete) => () => {
 
    const newFilters = filters.filter(chip => JSON.stringify(chip) !== JSON.stringify(chipToDelete));
    setFilters(newFilters);

    
    setSelectedFilters((prevState) => {
        const newState = { ...prevState };
        const key = Object.keys(chipToDelete)[0]; 
        delete newState[valueFilterQueryStringURL[key]];

     
        if (chipToDelete.search) {
            delete newState.search;
            setInputSearch('');
        }

        
        const params = new URLSearchParams(newState).toString();
        history.push({ search: params });

        if (props.onFilterChange) {
            props.onFilterChange(Object.keys(newState).length ? newState : {});
        }

        return newState;
    });
};


    const handleFilterUrl = (params) => {
        const filtersArr = Object.keys(params).map(k => {
            const labelKey = Object.keys(valueFilterQueryStringURL).find(
                key => valueFilterQueryStringURL[key] === k
            );
            if (!labelKey) return null;

            let options = [];
            if (labelKey === 'bundle') options = bundleOptions;
            if (labelKey === 'microcredential') options = microcredentialOptions;
            if (labelKey === 'badge') options = badgeOptions;

            const selectedOption = options.find(opt => String(opt.id) === String(params[k]));
            const labelValue = selectedOption ? selectedOption.label : params[k];

            return {
                [labelKey]: params[k],
                label: `${valueFilterLabels[labelKey]}: ${labelValue}`,
            };
        }).filter(Boolean);

        setFilters(filtersArr);
    };


    const handleApplyFilter = () => {
        setShowFilter(false);
        const cleanFilters = {};
        Object.entries(selectedFilters).forEach(([k, v]) => {
            if (v !== '' && v !== null && v !== undefined) cleanFilters[k] = v;
        });
        const params = new URLSearchParams(cleanFilters).toString();
        history.push({ search: params });
        if (props.onFilterChange) props.onFilterChange(cleanFilters);
    };

    const onChangeSearch = (e) => {
        const value = e.target.value;
        setInputSearch(value);

        if (props.onSearchChange) {
            props.onSearchChange(value);
        }
    };

    const handleSearchClick = () => {

        const searchValue = inputSearch.trim();
        const searchFilters = { ...selectedFilters, search: searchValue };
        const params = new URLSearchParams(searchFilters).toString();
        history.push({ search: params });

        if (props.onSearchChange) props.onSearchChange(searchValue);

        if (props.onFilterChange) props.onFilterChange(searchFilters);
    };



    return (
        <Card className={classes.cardHeader}>
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Paper component="form" className={classes.search}>
                            <IconButton className={classes.iconButton} aria-label="search" onClick={handleSearchClick}>
                                <SearchIcon />
                            </IconButton>
                            <InputBase
                                onChange={onChangeSearch}
                                className={classes.textArea}
                                placeholder="Buscar por microcredencial ó insignia "
                                name="searchUser"
                                value={inputSearch}
                                multiline
                                maxRows={4}
                            />
                        </Paper>
                    </Grid>

                    <Grid item xs={6}>
                        <Grid container justifyContent='flex-end'>
                            <Button
                                color="secondary"
                                variant="outlined"
                                className={clsx(classes.button, showFilter && classes.filterButton)}
                                disabled={loading}
                                onClick={() => setShowFilter(!showFilter)}
                                size="small"
                            >
                                <Typography variant='body2'>Filtro Avanzado</Typography>
                                <Icon className={clsx("text-white", "ri-equalizer-line", 'font-size-20')} fontSize='small' style={{ marginLeft: "6px" }} />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <ChipFilter chipData={filters} handleDelete={handleDeleteChip} />
                    </Grid>
                </Grid>

                {showFilter && (
                    <Grid container className={classes.grid} spacing={2}>
                        <Grid item xs={12} md={3}>
                            <TextField select label="Bundle" name="bundle" variant="outlined" fullWidth margin="dense"
                                onChange={handleChangeFilter} value={selectedFilters.bundleId || ""}>
                                {bundleOptions.map(opt => <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField select label="Microcredencial" name="microcredential" variant="outlined" fullWidth margin="dense"
                                onChange={handleChangeFilter} value={selectedFilters.microcredentialId || ""}>
                                {microcredentialOptions.map(opt => <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField select label="Insignia" name="badge" variant="outlined" fullWidth margin="dense"
                                onChange={handleChangeFilter} value={selectedFilters.badgeId || ""}>
                                {badgeOptions.map(opt => <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Box display="flex" alignItems="center" height="100%">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleApplyFilter}
                                    size="small"
                                    fullWidth
                                >
                                    <Typography variant='body2'>Aplicar</Typography>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </CardContent>
        </Card >
    );
};

const mapStateToProps = (state) => ({ ...state.userReducer });
export default connect(mapStateToProps)(RulesFilters);
